import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import { Avatar, FontIcon } from "material-ui";

import { Flex, Tipografia } from "../../../../_common";
import injectSheet from "../../../../_common/hocs/injectSheet/injectSheet";
import WhatsAppIcon from "../../../whatsapp/WhatsAppIcon";
import TimeLineItemEvento from "../TimeLineItemEvento/TimeLineItemEvento";
import TimeLineItemAtividade from "../TimeLineItemAtividade/TimeLineItemAtividade";
import TimeLineItemEmail from "../TimeLineItemEmail/TimeLineItemEmail";
import TimelineItemLogCadastro from "../TimelineItemLogCadastro/TimelineItemLogCadastro";
import TimelineItemLogWebHook from "../TimelineItemLogWebHook/TimelineItemLogWebHook";
import TimelineItemLogCRM from "../TimelineItemLogCRM/TimelineItemLogCRM";
import TimeLineItemWhatsApp from "../TimeLineItemWhatsApp/TimeLineItemWhatsApp";
import TimeLineItemEventoCustom from "../TimeLineItemEventoCustom/TimeLineItemEventoCustom";
import TimeLineItemPipedrive from "../TimeLineItemPipedrive/TimeLineItemPipedrive";

const styles = {
  evento: {
    minHeight: 100,
    position: "relative",
    zIndex: 1,
  },
  primeiroQuadrante: { width: 130 },
  segundoQuadrante: { marginBottom: 12, width: "75%" },
  divDataHora: { width: 80, paddingTop: 1 },
  divAvatar: { width: 50 },
  avatar: { flex: "none" },
  colorIconAtividades: { color: "#0000008A !important" },
  colorIconDetalheLead: { color: "#fff !important" },
  linhaPadrao: {
    width: 1,
    height: "100%",
  },
};

const TimeLineItem = ({
  timelineItens,
  itemTimeline,
  ultimo,
  podeAbrirLigacoes,
  podeEnviarEmail,
  index,
  mostraModalDetalheLog,
  handleAbrirModalDetalheLog,
  handleFechaModalDetalheLog,
  handleCopiarUrlWebhook,
  handleConcluirAtividade,
  handleEditarAtividade,
  lead,
  classes,
  isLinkPublico,
  leadId,
  isTimelineAtividades,
}) => {
  const intl = useIntl();
  const borderStyle =
    itemTimeline.tipoTimeline === 1
      ? `2px dashed ${isTimelineAtividades ? "#D9D9D9" : "#797979"}`
      : `2px solid ${isTimelineAtividades ? "#D9D9D9" : "#797979"}`;

  return (
    <Flex className={classes.evento} id="divTimeLineItem">
      <Flex className={classes.primeiroQuadrante}>
        <Flex flexDirection="column" alignItems="flex-end" className={classes.divDataHora}>
          <Tipografia>
            {intl.formatDate(itemTimeline.dataTimeStamp, { month: "short", day: "numeric", timeZone: "UTC" })}
          </Tipografia>
          <Tipografia tipo="notaLegendas" cor="darkSecondaryText">
            {intl.formatDate(itemTimeline.dataTimeStamp, {
              weekday: "short",
              timeZone: "UTC",
            })}{" "}
            {intl.formatTime(itemTimeline.dataTimeStamp, { hour12: false, timeZone: "UTC" })}
          </Tipografia>
        </Flex>
        <Flex alignItems="center" flexDirection="column" className={classes.divAvatar}>
          <Avatar
            id={itemTimeline.idIcone}
            size={32}
            backgroundColor={isTimelineAtividades ? "#D9D9D9" : "#797979"}
            icon={
              itemTimeline.icone === "whatsapp" ? (
                <WhatsAppIcon
                  className={isTimelineAtividades ? classes.colorIconAtividades : classes.colorIconDetalheLead}
                  size={22}
                />
              ) : (
                <FontIcon
                  className={`material-icons ${
                    isTimelineAtividades ? classes.colorIconAtividades : classes.colorIconDetalheLead
                  }`}
                >
                  {itemTimeline.icone}
                </FontIcon>
              )
            }
            className={classes.avatar}
          />

          {!ultimo && <div className={classes.linhaPadrao} style={{ borderRight: borderStyle }} />}
        </Flex>
      </Flex>
      <Flex className={classes.segundoQuadrante}>
        {itemTimeline.tipoTimeline === 0 &&
          !itemTimeline.eventoCustom &&
          !itemTimeline.email && (
            <TimeLineItemEvento
              evento={itemTimeline}
              podeAbrirLigacoes={podeAbrirLigacoes}
              index={index}
              isLinkPublico={isLinkPublico}
              isTimelineAtividades={isTimelineAtividades}
            />
          )}
        {itemTimeline.tipoTimeline === 0 &&
          !!itemTimeline.eventoCustom && (
            <TimeLineItemEventoCustom itemTimeline={itemTimeline} isTimelineAtividades={isTimelineAtividades} />
          )}
        {itemTimeline.tipoTimeline === 0 &&
          itemTimeline.email && (
            <TimeLineItemEmail
              podeEnviarEmail={podeEnviarEmail}
              email={itemTimeline.email}
              timelineItens={timelineItens}
              idPublico={leadId}
              isTimelineAtividades={isTimelineAtividades}
            />
          )}
        {itemTimeline.tipoTimeline === 1 && (
          <TimeLineItemAtividade
            atividade={itemTimeline}
            lead={lead}
            handleConcluirAtividade={handleConcluirAtividade}
            handleEditarAtividade={handleEditarAtividade}
            isTimelineAtividades={isTimelineAtividades}
          />
        )}
        {itemTimeline.tipoTimeline === 2 &&
          itemTimeline.flLogCadastro && (
            <TimelineItemLogCadastro evento={itemTimeline} isTimelineAtividades={isTimelineAtividades} />
          )}
        {itemTimeline.tipoTimeline === 2 &&
          itemTimeline.flLogWebHook && (
            <TimelineItemLogWebHook
              evento={itemTimeline}
              handleAbrirModalDetalheLog={handleAbrirModalDetalheLog}
              mostraModalDetalheLog={mostraModalDetalheLog}
              handleFechaModalDetalheLog={handleFechaModalDetalheLog}
              handleCopiarUrlWebhook={handleCopiarUrlWebhook}
              isTimelineAtividades={isTimelineAtividades}
            />
          )}
        {itemTimeline.tipoTimeline === 2 &&
          itemTimeline.flLogCrm && (
            <TimelineItemLogCRM evento={itemTimeline} isTimelineAtividades={isTimelineAtividades} />
          )}
        {itemTimeline.tipoTimeline === 3 && (
          <TimeLineItemWhatsApp
            isLinkPublico={isLinkPublico}
            evento={itemTimeline}
            isTimelineAtividades={isTimelineAtividades}
          />
        )}
        {itemTimeline.tipoTimeline === 2 &&
          itemTimeline.flLogPipedrive && (
            <TimeLineItemPipedrive evento={itemTimeline} isTimelineAtividades={isTimelineAtividades} />
          )}
      </Flex>
    </Flex>
  );
};

TimeLineItem.propTypes = {
  itemTimeline: PropTypes.object,
  ultimo: PropTypes.bool,
  podeAbrirLigacoes: PropTypes.bool,
  podeEnviarEmail: PropTypes.bool,
  classes: PropTypes.object,
  lead: PropTypes.object,
  index: PropTypes.number,
  mostraModalDetalheLog: PropTypes.bool,
  handleAbrirModalDetalheLog: PropTypes.func,
  handleFechaModalDetalheLog: PropTypes.func,
  handleCopiarUrlWebhook: PropTypes.func,
  handleConcluirAtividade: PropTypes.func,
  handleEditarAtividade: PropTypes.func,
  isLinkPublico: PropTypes.bool,
  leadId: PropTypes.string,
  timelineItens: PropTypes.array,
  isTimelineAtividades: PropTypes.bool,
};

export default injectSheet(styles)(TimeLineItem);
